import { render } from "./SMSCredits.vue?vue&type=template&id=12ebb49c&scoped=true"
import script from "./SMSCredits.vue?vue&type=script&lang=js"
export * from "./SMSCredits.vue?vue&type=script&lang=js"

import "./SMSCredits.vue?vue&type=style&index=0&id=12ebb49c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ebb49c"]])

export default __exports__